import {transient} from "aurelia-framework";
import { BaseRuleConfigPlugin } from "../../../../rules/dialogs/add-rule/plugins/base-rule-config-plugin";

@transient()
export class RequireRfi extends BaseRuleConfigPlugin {

    constructor(){
        super();
    }
}